import { useMediaQuery } from '@mui/material';

import { media } from 'atoms/breakpoints/breakpoints';

import InPageFeaturesHeading from 'components/InPageFeatures/InPageFeaturesHeading';
import InPageFeaturesMobile from 'components/InPageFeatures/InPageFeaturesMobile';
import InPageFeaturesV2 from 'components/InPageFeatures/InPageFeaturesV2';
import InPageFeaturesV3 from 'components/InPageFeatures/InPageFeaturesV3';

import type { FC } from 'react';

type InPageFeauturesProps = {
  content?: {
    raw: string | null;
  };
  sectionStyle?: string;
};

const InPageFeatures: FC<InPageFeauturesProps> = props => {
  const { sectionStyle } = props || {};

  let Component;

  const isDesktop = useMediaQuery(media.lg);

  if (isDesktop) {
    if (sectionStyle === 'V2 Style') {
      Component = <InPageFeaturesV2 {...props} />;
    } else if (sectionStyle === 'V3 Style') {
      Component = <InPageFeaturesV3 {...props} />;
    }
  } else {
    Component = <InPageFeaturesMobile {...props} />;
  }

  return (
    <>
      <InPageFeaturesHeading {...props} />
      {Component}
    </>
  );
};

export default InPageFeatures;
